import { Format, NumberFormatter } from '@zervant/reactcomponents'
import * as React from 'react'

import Input, { InputPropsInterface, InputState } from './Input/Input'
import { InputInterface } from './Input/InputInterface'

export interface NumberInputPropsInterface extends InputInterface<number> {
  decimals?: number
  minimum?: number
  maximum?: number
  formatter?: NumberFormatter
}

export class NumberInput extends React.Component<NumberInputPropsInterface, InputState<number>> {
  constructor(props: NumberInputPropsInterface) {
    super(props)

    this.state = {
      value: props.value,
      stringValue: props.formatter.render(props.value),
      hasBlurred: true,
    }
  }

  public UNSAFE_componentWillReceiveProps(props: NumberInputPropsInterface) {
    const stringValue = props.formatter.render(props.value)
    if (this.state.hasBlurred && (this.state.value !== props.value || this.state.stringValue !== stringValue)) {
      this.setState({
        value: props.value,
        stringValue,
        hasBlurred: true,
      })
    }
  }

  public static defaultProps: NumberInputPropsInterface = {
    value: 0,
    className: ['Number'],
    automation: '',
    decimals: 0,
    formatter: new NumberFormatter(Format.fromLocale()),
  }

  private getDefaultValue(): string {
    if (this.props.minimum > 0) {
      return '' + this.props.minimum
    }

    return '0'
  }

  private isValid(value: number): boolean {
    const a = ('' + value).split('.')
    if (a.length > 1 && this.props.decimals < a[1].length) {
      return false
    }

    if (this.props.minimum !== undefined && value < this.props.minimum) {
      return false
    }

    if (this.props.maximum !== undefined && value > this.props.maximum) {
      return false
    }

    return true
  }

  public render(): JSX.Element {
    let value = this.getDefaultValue()
    if (this.props.onChange) {
      value = '' + this.props.value
    } else {
      value = '' + this.state.stringValue
    }

    const props: InputPropsInterface = {
      ...this.props,
      value: '' + value,
      onChange: (value: string, stringValue: string) => {
        const formatted = this.props.formatter.read(value)

        if (this.isValid(formatted)) {
          this.setState({
            ...this.state,
            value: formatted,
            stringValue,
          })

          if (this.props.onChange) {
            this.props.onChange(this.props.formatter.read(value))
          }
        }
      },
      onBlur: (value: string) => {
        if (this.props.onBlur) {
          this.props.onBlur(this.state.value)
        }
      },
      className: ['Number'],
    }

    return <Input {...props} />
  }
}
